import React, { useEffect, useRef, useState } from "react";

import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import axios from "../../axios";
import { useNavigate } from "react-router-dom";
import { phoneFormat } from "../../constants/api";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import useMixpanel from "../../hooks/useMixpanel";

const ModalMaintenance = ({
  show,
  setShow,
  category,
  room_uuid,
  text,
  theme,
  company_id,
  selectedCategory,
  requiredFields,
}) => {
  const { track } = useMixpanel();
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [phone, setPhone] = useState("");
  const [note, setNote] = useState("");
  const [files, setFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [errPhone, setErrPhone] = useState("");
  const [responseLinks, setResponseLinks] = useState([]);
  const [selectedNote, setSelectedNote] = useState();
  const [openOtherNotes, setOpenOtherNotes] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState("");
  const loaderRef = useRef(null);
  const newDesign = localStorage.getItem("new_design");
  const currency = localStorage.getItem("currency");

  console.log("category", category);

  const { t } = useTranslation();

  const navigate = useNavigate();
  const handelChangImage = async (e) => {
    setLoading(true);
    const formData = new FormData();
    // console.log("imagessssssssssss", e.target.files[0]);
    setFiles([...files, e.target.files[0]]);
    // setImage(e.target.files[0]);
    formData.append("file", e.target.files[0]);
    // console.log("files", files);

    await axios
      .post(`/${room_uuid}/maintenance/upload-document`, formData)
      .then((res) => {
        // images.push(res.data.data);

        console.log("res.data.data", res.data.data);
        setResponseLinks((prevLinks) => [...prevLinks, res.data.data]);
        setPreviewUrls([
          ...previewUrls,
          URL.createObjectURL(e.target.files[0]),
        ]);
        setLoading(false);
        // console.log("imagesimages", responseLinks);
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
      });
    // console.log("imagesimages", responseLinks);
  };
  useEffect(() => {
    setResponseLinks([]);
    setFiles([]);
    setPreviewUrls([]);
    setPhone("");
  }, [category]);

  const handleClose = () => {
    setShow(false);
    setResponseLinks([]);
    setFiles([]);
    setPhone("");
    setPreviewUrls([]);
    setPaymentUrl("");
  };

  const handleIframeLoad = () => {
    if (loaderRef.current) {
      loaderRef.current.style.display = "none";
      loaderRef.current.style.visibility = "hidden";
      loaderRef.current.remove();
    }
  };

  const dataForm = {
    phone: phone.phone,
    note: selectedNote ? selectedNote.name : note,
    note_id: selectedNote ? selectedNote.id : null,
    category: category,
    company: company_id,
    maintenance_images: Object.values(responseLinks),
    redirect_url: `https://${window.location.host}/${room_uuid}/MaintenanceCallback`,
  };

  const handelBook = () => {
    if (!dataForm.phone && requiredFields.phoneRequired)
      return setErrPhone("The phone field is required.");
    setIsDisabled(true);
    axios
      .post(`/${room_uuid}/maintenance/book-category`, dataForm)
      .then((res) => {
        console.log("ressssss", res);
        if (res.data.status) {
          track.orderSubmitted({
            order_id: res.data.data?.orderId || "",
            order_number: res.data.data?.orderNumber || "",
            service_type: "maintenance",
            order_source: localStorage.getItem("room_type") || "room",
            items_count: 1,
            subtotal: 0,
            tax: 0,
            delivery_fee: 0,
            other_fees: 0,
            total_amount: 0,
            is_external_service: false,
          });
          if (res.data.data?.payment_url) {
            if (res.data.data?.is_embedded) {
              // if (true) {
              setPaymentUrl(res.data.data.payment_url);
            } else {
              window.location.href = res.data.data.payment_url;
            }
          } else {
            navigate(`/${room_uuid}/MaintenanceOrderPlaced`, {
              state: {
                metadata: {
                  res: res.data.data,
                },
              },
            });
            setResponseLinks([]);
            setFiles([]);
            setPreviewUrls([]);
            setPhone("");
          }
        }
        setIsDisabled(false);
      })
      .catch((err) => {
        setIsDisabled(false);
        console.log(err);
      });
  };
  const removeItem = (index) => {
    console.log("this index", index);
    // Create a new array without the item at the specified index
    const updatedResponseLink = [
      ...responseLinks.slice(0, index),
      ...responseLinks.slice(index + 1),
    ];
    const updatedPreviewUrls = [
      ...previewUrls.slice(0, index),
      ...previewUrls.slice(index + 1),
    ];

    setResponseLinks(updatedResponseLink);
    setPreviewUrls(updatedPreviewUrls);
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      className={`custom-width pt-4 ${theme ? "food-modal" : ""}`}
      style={{ maxHeight: "90vh" }}
    >
      <Modal.Body>
        <button
          type="button"
          className="button close-pop"
          onClick={handleClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24.054"
            height="24.625"
            viewBox="0 0 24.054 24.625"
          >
            <defs></defs>
            <path
              id="Icon_ionic-ios-close-circle"
              data-name="Icon ionic-ios-close-circle"
              className="cls-50"
              d="M15.4,3.375A12.17,12.17,0,0,0,3.375,15.687,12.17,12.17,0,0,0,15.4,28,12.17,12.17,0,0,0,27.429,15.687,12.17,12.17,0,0,0,15.4,3.375Zm3.047,16.77L15.4,17.025l-3.047,3.12a.913.913,0,0,1-1.307,0,.959.959,0,0,1,0-1.338l3.047-3.12-3.047-3.12a.959.959,0,0,1,0-1.338.913.913,0,0,1,1.307,0L15.4,14.35l3.047-3.12a.913.913,0,0,1,1.307,0,.966.966,0,0,1,0,1.338l-3.047,3.12,3.047,3.12a.966.966,0,0,1,0,1.338A.9.9,0,0,1,18.449,20.145Z"
              transform="translate(-3.375 -3.375)"
            ></path>
          </svg>
        </button>
        <div className="body-container maintenance ">
          {/* <div className="img-pnl">
            <img className="mod_img" src={imageMod} />
          </div> */}
          <h4>{text}</h4>
          <div className="content-pnl">
            <div className="input-pnl">
              <Row>
                {selectedCategory &&
                  selectedCategory.notes &&
                  selectedCategory.notes.length > 0 && (
                    <div>
                      <p
                        className="mx-3 font-semibold"
                        style={{ color: newDesign === "true" ? "white" : "" }}
                      >
                        {t("select problem")}
                      </p>
                      <div className="  px-3 mb-4 ">
                        {selectedCategory.notes.map((note) => (
                          <div
                            className=" mb-3 "
                            style={{
                              gap: "5px",
                              alignItems: "center",
                              display: newDesign === "true" ? "flex" : "block",
                              color: newDesign === "true" ? "white" : "black ",
                            }}
                          >
                            <Form.Check
                              type="radio"
                              checked={
                                selectedNote && selectedNote.id === note.id
                              }
                              onClick={() => {
                                setSelectedNote(note);
                                setOpenOtherNotes(false);
                                setPaymentUrl("");
                              }}
                            />
                            <span>
                              {note.name}
                              {parseFloat(note.price) > 0 && (
                                <span
                                  style={{
                                    marginInlineStart: "6px",
                                    opacity: 0.75,
                                  }}
                                >
                                  ({parseFloat(note.price).toFixed(0)}{" "}
                                  {currency})
                                </span>
                              )}
                            </span>
                          </div>
                        ))}
                        <div
                          className="mt-3"
                          style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                            color: newDesign === "true" ? "white" : "black",
                          }}
                        >
                          <Form.Check
                            type="radio"
                            // label={"Other"}
                            checked={openOtherNotes}
                            onClick={() => {
                              setSelectedNote(null);
                              setPaymentUrl("");
                              setOpenOtherNotes(true);
                            }}
                          />
                          <span>{t("Other")}</span>
                        </div>
                      </div>
                    </div>
                  )}
                {(openOtherNotes ||
                  (selectedCategory &&
                    selectedCategory.notes &&
                    selectedCategory.notes.length <= 0)) && (
                  <Col xs="12">
                    <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                      <Form.Control
                        as="textarea"
                        placeholder={t(`Note (optional)`)}
                        name="note"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        style={{ height: "106px" }}
                      />
                    </Form.Group>
                  </Col>
                )}
                <Col xs="12">
                  <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                    <PhoneInputComponent
                      onChange={(phone) => {
                        setPhone((prev) => ({ ...prev, phone }));
                      }}
                    />
                  </Form.Group>
                  {errPhone !== "" && (
                    <span className="err_msg">{t(`${errPhone}`)}</span>
                  )}
                </Col>

                <Col xs="12">
                  {loading ? (
                    <>
                      <label htmlFor="choseImage" className="chose_img_mani">
                        Loading...
                      </label>
                      <div htmlFor="choseImagem" className="droupzo_">
                        {/* Loading */}
                        <div className="drop_c">
                          {previewUrls.map((url, index) => (
                            <div>
                              <img key={index} src={url} alt="" />
                              <i
                                class="fas fa-times"
                                onClick={() => removeItem(index)}
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <label htmlFor="choseImage" className="chose_img_mani">
                        <i class="fas fa-images"></i>{" "}
                        {t("Attach Images") + " " + "(" + t("Optional") + ")"}
                      </label>
                      <div className="droupzo_">
                        <div className="drop_c">
                          {previewUrls.map((url, index) => (
                            <div>
                              <img key={index} src={url} alt="" />
                              <i
                                class="fas fa-times"
                                onClick={() => removeItem(index)}
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                      <input
                        type="file"
                        id="choseImage"
                        className="d-none"
                        onChange={handelChangImage}
                      />
                    </>
                  )}
                  {/* <label htmlFor="choseImage" className="droupzo_">
                    {loading ? "Loading" : "Chose Imgee"}
                    <div>
                      {previewUrls.map((url, index) => (
                        <img key={index} src={url} />
                      ))}
                    </div>
                  </label>
                  <input
                    type="file"
                    id="choseImage"
                    className="d-none"
                    onChange={handelChangImage}
                  /> */}
                </Col>

                {(() => {
                  const totalPrice =
                    parseFloat(selectedCategory?.price || 0) +
                    (!openOtherNotes
                      ? parseFloat(selectedNote?.price || 0)
                      : 0);
                  return totalPrice > 0 ? (
                    <Col xs="12">
                      <p
                        className=""
                        style={{
                          color: newDesign === "true" ? "white" : "black",
                          fontWeight: "600",
                        }}
                      >
                        {t("Price")}: {totalPrice.toFixed(2)} {currency}
                      </p>
                    </Col>
                  ) : null;
                })()}
              </Row>
            </div>
            <div className="spacer-40"></div>
            {!paymentUrl && (
              <div className="padd-div text-center mb-2 ">
                <Button
                  className="reg-btn book fw-normal"
                  onClick={handelBook}
                  disabled={isDisabled}
                >
                  {t(`request`)}
                </Button>
              </div>
            )}
          </div>
        </div>
        {paymentUrl && (
          <div className="payment-iframe">
            <div className="d-flex justify-content-center m-5" ref={loaderRef}>
              <div
                className="loader"
                style={{
                  borderColor: "lightgray",
                  borderRightColor: "#000000",
                }}
              ></div>
            </div>
            <iframe
              loading="lazy"
              src={paymentUrl}
              width="100%"
              title="Payment Preview"
              scrolling="no"
              onLoad={handleIframeLoad}
            ></iframe>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalMaintenance;
